module.exports = __webpack_public_path__ + "static/img/data_1.d639045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data_1.jpg
// module id = LfBG
// module chunks = 1